<template>
  <!-- Navbar -->
  <nav class="main-header navbar navbar-expand navbar-white navbar-light">
    <!-- Left navbar links -->
    <ul class="navbar-nav">
      <li class="nav-item">
        <a class="nav-link" data-widget="pushmenu" href="#" role="button"><i class="fas fa-bars"></i></a>  
      </li>
    </ul>

    <!-- Right navbar links -->
    <ul class="navbar-nav ml-auto">
      <!-- Dropdown Menu -->
      <li class="nav-item dropdown" :class="{show: showUserMenu}" @click="showUserMenu = !showUserMenu">
        <b-dropdown variant="link" right toggle-class="text-decoration-none" no-caret>
          <template #button-content>
            <div class="image">
              <img src="@/assets/img/user2-160x160.jpg" class="img-circle" alt="User Image" style="height: 24px; width: 24px">
            </div>
          </template>
          <b-dropdown-header>
            {{ loggedInUser.username }}
          </b-dropdown-header>
          <b-dropdown-item :to="{name: 'Profile'}">
            My Profile
          </b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item-button @click.prevent="logout()">
            <i class="fas fa-lock mr-2"></i> Sign Out
          </b-dropdown-item-button>
        </b-dropdown>
      </li>
    </ul>
  </nav>
  <!-- /.navbar -->
</template>

<script>
import {clearUserData} from "@/helpers/Utils";
import {
  BDropdown, BDropdownItem, BDropdownItemButton,
  BDropdownDivider, BDropdownHeader,
} from "bootstrap-vue";
import {userInfoMixin} from "@/mixins/userInfoMixin";

export default {
  name: "NavBar",
  mixins: [
      userInfoMixin,
  ],
  components: {
    BDropdown,
    BDropdownItem,
    BDropdownItemButton,
    BDropdownDivider,
    BDropdownHeader,
  },
  data: ()=>({
    showNotif: false,
    showUserMenu: false,
  }),
  methods: {
    logout(){
      clearUserData();
      location.reload();
    },
  },
}
</script>

<style scoped>

</style>
